"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchoolOptions = void 0;
var lodash_1 = require("lodash");
/** Настройки школы */
var SchoolOptions = /** @class */function () {
  function SchoolOptions(values) {
    values.onclassPercent = Math.min(Math.max(0, values.onclassPercent), 100);
    values.tutorPercentMin = Math.min(Math.max(0, values.tutorPercentMin), 100);
    values.tutorPercentMax = Math.min(Math.max(0, values.tutorPercentMax), 100);
    values.tutorPercentStep = Math.min(Math.max(0, values.tutorPercentStep), 100);
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, this.getProperties()));
  }
  SchoolOptions.prototype.getProperties = function () {
    return ['onclassPercent', 'tutorPercentMin', 'tutorPercentMax', 'tutorPercentStep'];
  };
  return SchoolOptions;
}();
exports.SchoolOptions = SchoolOptions;
